<section id="rep-param-maint">    
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>
        <!-- Container for Report Parameter Table using prime ng -->
        <div class = 'table-user'>
            <osp-table [tblConfig]="repParamTblConfig" (onRowClick)="onRowClick($event)"></osp-table>
        </div>
        <!-- Loading Animation -->
        <div id="rep-param-maintenance-loading">
            <div class="form-loader"></div>
        </div>
        <div class="form-content" *ngIf="showForm">
            <form [formGroup]="forms.repParamForm" class="form">
                <div id="rep-param-error-message"></div>
                <div class="form-container-grid">
                    <div class="field required">
                        <label>Report ID</label>
                    </div>
                    <div class="">
                        <input formControlName="reportID" type="text" maxlength="25" (input)="autoUppercase($event)">
                    </div>
                    <div class="field required">
                        <label>Parameter Type</label>
                    </div>
                    <div class="">
                        <select formControlName="paramType" (change)="onParamTypeChange($event)">
                            <option *ngFor="let paramType of selections.paramTypes" [value]="paramType.cd">
                                {{paramType.name}}
                            </option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>Parameter Name</label>
                    </div>
                    <div class="span">
                        <input formControlName="paramName" type="text" maxlength="50" (input)="autoUppercase($event)">
                    </div>
                    
                    <div class="field" [class.required]="paramTypeEnabled === 'V'">
                        <label>Parameter (Characters)</label>
                    </div>
                    <div class="span">
                        <input formControlName="paramValueV" type="text">
                    </div>

                    <div class="field" [class.required]="paramTypeEnabled === 'N'">
                        <label>Parameter (Number)</label>
                    </div>
                    <div class="">
                        <input class="currency" formControlName="paramValueN" (focus)="_formService.setFieldToNumberWithDecimal(forms.repParamForm, 'paramValueN', $event)"
                        (blur)="_formService.setFieldToAmountFormat(forms.repParamForm, 'paramValueN', $event)" (keypress)="allowNumericDigitsOnly($event)">
                    </div>
                    <div class="field" [class.required]="paramTypeEnabled === 'D'">
                        <label>Parameter (Date)</label>
                    </div>
                    <div class="">
                        <input formControlName="paramValueD" type="text" placeholder="MM/DD/YYYY" [matDatepicker]="paramValueDPicker" (keypress)="allowNumericAndSlashOnly($event)">
                        <mat-datepicker-toggle matSuffix [for]="paramValueDPicker"></mat-datepicker-toggle>
                        <mat-datepicker #paramValueDPicker></mat-datepicker>
                    </div>
                    
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text" maxlength="4000">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="userID">
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUserUpdate">
                    </div>
                </div>
            </form>
            <div class="btn-row">
                <button *ngIf="btns.repParam.updateDisabled" class="btn btn2" type="button" (click)="onAdd()">ADD</button>
                <button *ngIf="!btns.repParam.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()">UPDATE</button>
                <button class="btn btn2" type="button" [disabled]='btns.repParam.deleteDisabled' (click)="onDelete()"> DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-row">
                <button class="btn btn2" type="button" [disabled]='btns.repParam.saveDisabled' (click)="onSave()">SAVE</button>
            </div>
        </div>
    </div>
</section>